import http from "../http-common";
import authHeader from './auth-header';

class transactionService {
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TRANSACTIONS

createTransaction(data) {
    return http.post("/transactions/a_transactions/create", data, { headers: authHeader() });
  }

  getAllTransactions() {
    return http.get("/transactions/a_transactions", { headers: authHeader() });
  }

  getManagementAccounts(data) {
    return http.post("/transactions/management_accounts", data, { headers: authHeader() });
  }

  getAccountBalances(AccountID, data) {
    return http.post(`/transactions/a_transactions/balances/${AccountID}`, data, { headers: authHeader() });
  }

  getAllSettlements() {
    return http.get("/transactions/settlements", { headers: authHeader() });
  }

  getAllDividendSettlements() {
    return http.get("/transactions/dividend_settlements", { headers: authHeader() });
  }

  getAllFeeSettlements() {
    return http.get("/transactions/fee_settlements", { headers: authHeader() });
  }

  getTransaction(TxnId) {
    return http.get(`/transactions/a_transactions/${TxnId}`, { headers: authHeader() });
  }

  updateTransaction(TxnId, data) {
    return http.put(`/transactions/a_transactions/update/${TxnId}`, data, { headers: authHeader() });
  }

  updateSettlement(data) {
    return http.post("/transactions/settlements/update", data, { headers: authHeader() });
  }

  updateDividendSettlement(data) {
    return http.post("/transactions/dividend_settlements/update", data, { headers: authHeader() });
  }

  updateFeeSettlement(data) {
    return http.post("/transactions/fee_settlements/update", data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CORPORATE EVENTS

  createCorpEvent(data) {
    return http.post("/administration/corp_events/create", data, { headers: authHeader() });
  }

  getAllCorpEvents() {
    return http.get("/administration/corp_events", { headers: authHeader() });
  }

  getAllCorpEventTypes() {
    return http.get("/administration/corp_event_types", { headers: authHeader() });
  }

  getAllCorpEventTypesByID(CorporateEventID) {
    return http.get(`/administration/corp_event_types/${CorporateEventID}`, { headers: authHeader() });
  }

  updateCorpEvent(CorporateEventID, data) {
    return http.put(`/administration/corp_events/update/${CorporateEventID}`, data, { headers: authHeader() });
  }

  deleteCorpEvent(CorporateEventID) {
    return http.delete(`/administration/corp_events/delete/${CorporateEventID}`, { headers: authHeader() });
  }
}

export default new transactionService();